import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h1 {
    font-weight: 600;
    font-size: 24px;
    margin: 10px 5px;
  }
`;

export const SamePatientContainer = styled.div`
  height: var(--height-body-without-header);
  margin-top: 30px;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;
